module.exports = __webpack_public_path__ + "assets/CircleTangentL.a027519672830c045b1c217029c908f3.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/CircleTangentL.gmt
// module id = 927
// module chunks = 0